"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.LegalTextBlockDefaultProps = exports.LegalTextBlock = void 0;
var _legalTextBlock = _interopRequireDefault(require("./components/legal-text-block"));
exports.LegalTextBlock = _legalTextBlock["default"];
var _legalTextBlock2 = _interopRequireDefault(require("./components/legal-text-block.props/legal-text-block.defaultProps"));
exports.LegalTextBlockDefaultProps = _legalTextBlock2["default"];